import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, TextField, Button } from '@mui/material';

// The All / Pending / Cancelled / Deleted toggle and the date range that sits beside it.
//
// Shared by the invoice and payment lists so the two screens cannot drift apart — they are
// the same four questions asked of two tables, and a user who learns one should not have to
// re-learn the other.
//
// The toggle is deliberately not another dropdown in the filter row. These four are the
// coarse "which set of records am I looking at" question, asked before any of the finer
// filtering; burying them among the others would hide the fact that Deleted records exist
// at all, which is the whole reason they were surfaced.
export const DEFAULT_VIEWS = [
  { value: 'all', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'deleted', label: 'Deleted' }
];

const ListViewControls = ({
  view,
  onViewChange,
  views = DEFAULT_VIEWS,
  from,
  to,
  onDateChange,
  dateLabel = 'Date'
}) => {
  const hasDates = Boolean(from || to);

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 2,
        mb: 2
      }}
    >
      <ToggleButtonGroup
        size="small"
        exclusive
        value={view}
        // exclusive ToggleButtonGroup hands back null when the active button is clicked
        // again. Passing that straight through would leave no view selected and no rows
        // filtered by anything, so a re-click is treated as "stay put".
        onChange={(_e, next) => { if (next !== null) onViewChange(next); }}
      >
        {views.map((v) => (
          <ToggleButton key={v.value} value={v.value} sx={{ px: 2 }}>
            {v.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TextField
          size="small"
          type="date"
          label={`${dateLabel} from`}
          value={from || ''}
          onChange={(e) => onDateChange({ from: e.target.value, to })}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 165 }}
        />
        <TextField
          size="small"
          type="date"
          label={`${dateLabel} to`}
          value={to || ''}
          onChange={(e) => onDateChange({ from, to: e.target.value })}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 165 }}
        />
        {/* Only once there is something to clear. A permanently visible Clear button on an
            empty range is a control that does nothing, which teaches people to ignore it. */}
        {hasDates && (
          <Button size="small" onClick={() => onDateChange({ from: '', to: '' })}>
            Clear dates
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ListViewControls;
